module.exports = require('./helpers/bundle-url').getBundleURL('jPd2H') + "life-buoy.285e728c.webp";